import config from "../config"
const baseUrl = config.base_url + "z_farm_work_type/"
export default {
    page: {
        url: baseUrl + "page/{page}/{limit}",
        type: "get",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    delete: {
        url: baseUrl + "delete",
        type: "get",
    },
    get: {
        url: baseUrl + "get",
        type: "get",
    },
    list: {
        url: baseUrl + "list",
        type: "get",
    },
    listByName: {
        url: baseUrl + "listByName",
        type: "get",
    },
    listByCode: {
        url: baseUrl + "listByCode",
        type: "get",
    },
    pesticideCount: {
        url: baseUrl + "pesticide_count",
        type: "get",
    }
} 